module.exports = __webpack_public_path__ + "img/logo_2.e29cf85c.png";